module.exports = __webpack_public_path__ + "img/VZvx.c42491a4.gif";